import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  const yesItems = ['Quieres proteger a tu familia o planificar gastos finales', 'Quieres entender antes de comprar', 'Prefieres información clara y apoyo en español'];
  const noItems = ['Buscas promesas de precio sin evaluación', 'No te interesa informarte ni tomar acción'];
  return <section className="bg-cream py-20 px-6" data-id="element-81">
      <div className="max-w-5xl mx-auto" data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold" data-id="element-84">
            ¿Es para ti?
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" data-id="element-85" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-86">
          {/* YES Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 shadow-soft border-t-4 border-whatsapp" data-id="element-87">
            <h3 className="font-heading text-2xl text-navy font-bold mb-6 flex items-center gap-3" data-id="element-88">
              <span className="bg-whatsapp/10 text-whatsapp p-2 rounded-full" data-id="element-89">
                <CheckIcon className="w-6 h-6" data-id="element-90" />
              </span>
              Sí, si tú:
            </h3>
            <ul className="space-y-5" data-id="element-91">
              {yesItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-92">
                  <CheckIcon className="w-5 h-5 text-whatsapp flex-shrink-0 mt-0.5" data-id="element-93" />
                  <span className="text-gray-700 font-medium" data-id="element-94">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-8 shadow-soft border-t-4 border-red-400 opacity-90" data-id="element-95">
            <h3 className="font-heading text-2xl text-navy font-bold mb-6 flex items-center gap-3" data-id="element-96">
              <span className="bg-red-50 text-red-500 p-2 rounded-full" data-id="element-97">
                <XIcon className="w-6 h-6" data-id="element-98" />
              </span>
              No, si tú:
            </h3>
            <ul className="space-y-5" data-id="element-99">
              {noItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-100">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-101" />
                  <span className="text-gray-600" data-id="element-102">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}